module.exports = __webpack_public_path__ + "img/gartek-portfolio-design-build.0710c15d.jpeg";